import BaseModal from "components/baseModal/baseModal";
import { useSelector } from "react-redux";
import { ModalBaseProps } from "redux/models/modalModels";
import { RootState } from "redux/store";
import { ModalTypeEnum } from "utils/enums";
import "./baseModalContainer.scss";
import CreateEmployeeModal from "./createEmployeeModal/createEmployeeModal";
import CreateOrEditApiKeyModal from "./createOrEditApiKeyModal/createOrEditApiKeyModal";
import DeleteModal from "./deleteModal/deleteModal";
import DisableApiKeyModal from "./disableApiKeyModal/disableApiKeyModal";
import ExportModal from "./exportModal/exportModal";
import FeedbackFormModal from "./feedbackFormModal/feedbackFormModal";
import ReportDetailsModal from "./reportDetailsModal/reportDetailsModal";
import SpecialMenuColumnModal from "./specialMenuModal/specialMenuColumnModal/specialMenuColumnModal";
import SpecialMenuFilterModal from "./specialMenuModal/specialMenuFilterModal/specialMenuFilterModal";
import CreateOrEditWebhooks from "./createOrEditWebhooksModal/createOrEditWebhooksModal";

const modalMapping: { [modalType in ModalTypeEnum]: React.ComponentType<any> } = {
    [ModalTypeEnum.ExportModal]: ExportModal,
    [ModalTypeEnum.DeleteModal]: DeleteModal,
    [ModalTypeEnum.CreateEmployee]: CreateEmployeeModal,
    [ModalTypeEnum.DetailsModal]: ReportDetailsModal,
    [ModalTypeEnum.FeedbackFormModal]: FeedbackFormModal,
    [ModalTypeEnum.SpecialMenuColumnModal]: SpecialMenuColumnModal,
    [ModalTypeEnum.SpecialMenuFilterModal]: SpecialMenuFilterModal,
    [ModalTypeEnum.CreateOrEditApiKey]: CreateOrEditApiKeyModal,
    [ModalTypeEnum.DisableApiKey]: DisableApiKeyModal,
    [ModalTypeEnum.Confirm]: BaseModal,
    [ModalTypeEnum.CreateOrEditWebhooks]: CreateOrEditWebhooks,
    [ModalTypeEnum.None]: () => <></>,
};
function BaseModalContainer() {
    const { modalDescriptors } = useSelector((state: RootState) => state.modal);

    if (modalDescriptors.length === 0) {
        return <></>;
    }

    return (
        <>
            {modalDescriptors
                .filter(x => x.isOpened)
                .map((value: ModalBaseProps) => {
                    const Modal = modalMapping[value.modalType];
                    return <Modal key={value.modalType} {...value.props} />;
                })}
        </>
    );
}

export default BaseModalContainer;
